import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@sortenv/environment';
import { Store, StoreModule } from '@ngrx/store';
import { ShellSortimentierenModule } from '@sortapp/shell/shell.module';
import { CommonCheckService,  FoxyLibModule, SwitchThemeService, EnvironmentService, AuthService, LipoMessageService, GuiService } from 'FoxxyLib';
import { filter, Observable, of, take } from 'rxjs';

import { authConfig } from './oauth.config';
import { ToastModule } from 'primeng/toast';


import { MessageService, ToastMessageOptions } from 'primeng/api';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { ISortimentierenConnections, ISortimentierenEnvironment } from 'FoxxyInterfaces';
import { SignalRService } from './services/common/signalr.service';


import { PrimeNG } from 'primeng/config';


import { Apollo } from 'apollo-angular';







@Component({
    selector: 'app-root',
    imports: [FoxyLibModule, ShellSortimentierenModule, CommonModule, ToastModule, TranslateModule,
    ],
    standalone: true,
    providers: [SwitchThemeService,  CommonCheckService, TranslateService, MessageService, LipoMessageService<ToastMessageOptions>, SignalRService, Apollo],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  isLoggedIn$  : Observable<boolean> = of(true);

  constructor( private switchThemeServiceLib: SwitchThemeService,
    private messageService : MessageService,
    private lipomessageService : LipoMessageService<ToastMessageOptions>,
    private primeConfig: PrimeNG,
    private translateService: TranslateService,
    private signalRService : SignalRService,
    private authService: AuthService,
    private store: Store<any>, private environmentService : EnvironmentService<ISortimentierenEnvironment>)  {
     const styles = this.switchThemeServiceLib.possibleStyles;
     console.debug('AppComponent.constructor Sortimentieren: styles = ' + styles);

    this.isLoggedIn$ = this.authService.isAuthenticated$;
      this.isLoggedIn$.subscribe((isAuthenticated) => {
        console.debug('AppComponent.constructor Sortimentieren: isAuthenticated = ' + isAuthenticated);
      })

      this.primeConfig.setTranslation({
            dayNames: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
            dayNamesShort: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
            dayNamesMin: [ 'S', 'M', 'D', 'M', 'D', 'F', 'S' ],
            monthNames: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
            monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
            today: 'Heute',
            clear: 'Löschen',
            noFilter: 'Filter entfernen'
      });
      this.translateService.setDefaultLang('de');
      this.isLoggedIn$.pipe(filter(f=> f == true), take(1)).subscribe(isLoggedIn => {
        this.signalRService.init(this.authService);
        })

  }
  ngOnInit(): void {

      this.lipomessageService.SubMessage.pipe(filter(f=> f!= undefined && f.severity != undefined && f.summary != undefined)).subscribe(message =>
        {
            this.messageService.add(message);
        });
  }

  title = 'Sortimentieren';
}
